import {
    Dialog,
    DialogTitle,
    Button,
    DialogContent,
    TableHead,
    TableRow,
    TableCell,
    Table,
    TableContainer,
    TableBody,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Tooltip,
} from "@material-ui/core";
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editarDetalleCotizaciones, EliminarMaterialCotizacion, enviarMailPedidoCotizacion } from "../../../actions/compras/Cotizaciones";
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import React from "react";
import { FormNuevoMaterial } from "../Materiales/FormNuevoMaterial";
import ModalAbm from "../../compartidos/abms/ModalAbm";
import { ModalDocumentacion } from "../Documentacion/ModalDocumentacion";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";
import { startAlerta } from "../../../actions/ui/alertas";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { ModalCargarOferente } from "./ModalCargarOferente";
import { ESTADOS_COTIZACIONES } from "../../../utils/constants";

export const ModalCargarCotizacion = memo((props) => {
    const { cabeceraCotizacion, idEstado, idSolicitud, esEdicion, idOferenteEdicion, idTipoSolicitud, cotizacion } = props;
    const dispatch = useDispatch();
    const [idOferente, setOferentes] = useState(0);
    const oferentes = cabeceraCotizacion.map(x => x.oferentes);

    const [openMaterial, setMaterialAlta] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDocumentacion, setDocumentacionAlta] = useState(false);
    const [info, setInfo] = useState([]);
    const [material, setMaterial] = useState();
    const [confirmarEliminarMaterial, setConfirmarEliminarMaterial] = useState(false);
    const { materialCompras } = useSelector((state) => state.compras);
    const cabeceraElegida = cabeceraCotizacion.filter(x => x.idOferente === Number(idOferente));
    const detalleCotizaciones = cabeceraElegida.map(x => x.detalleCotizaciones)
    const [openModalCargarOferente, setOpenModalCargarOferente] = useState(false);
    if (detalleCotizaciones.length > 0 && info.length === 0) {
        detalleCotizaciones.map((item) => (
            item.forEach(a => {
                let documentacion = {};
                if (a.fechaBaja === null) {
                    documentacion = {
                        cantidadCotizada: a.cantidadCotizada,
                        cantidad: a.cantidad,
                        valorUnitario: a.valorUnitario,
                        fechaEntrega: a.fechaEntrega,
                        observaciones: a.observaciones,
                        idDetalleCotizacion: a.idDetalleCotizacion,
                        idCotizacionCabecera: a.idCotizacionCabecera,
                        idOferente: idOferente,
                        idMaterial: a.idMaterial,
                        material: a.materiales.descripcion,
                        agregadoCompras: a.agregadoCompras
                    }
                    info.push(documentacion)
                }
            })
        ))
    }

    const handleItemSelectEliminar = (item) => {
        setMaterial(item);
        setConfirmarEliminarMaterial(true);
    }
    const handleItemSelect = (item) => {
        debugger
        setMaterial(item);
        setOpen(true);
    }

    const handleEdit = (item) => {
        let value = info.filter((a) => a.idMaterial === item.idMaterial);
        if (value.length > 0) {
            debugger
            setInfo(
                info.map((a) => a.idMaterial === item.idMaterial ?
                    {
                        cantidad: item.cantidad,
                        cantidadCotizada: item.cantidadCotizada,
                        valorUnitario: item.valorUnitario,
                        fechaEntrega: item.fechaEntrega,
                        observaciones: item.observaciones,
                        material: a.material,
                        idDetalleCotizacion: a.idDetalleCotizacion,
                        idCotizacionCabecera: a.idCotizacionCabecera,
                        idOferente: a.idOferente,
                        agregadoCompras: item.agregadoCompras,
                        idMaterial: a.idMaterial
                    }
                    :
                    a
                ))
        }
    }
    const handleEliminar = () => {
        debugger
        if (material.idDetalleCotizacion) {
            dispatch(EliminarMaterialCotizacion(material.idDetalleCotizacion, idEstado, idTipoSolicitud));
        }
        var materialFilter = info.filter(x => x.idMaterial !== material.idMaterial);
        setInfo(materialFilter);
    }

    const handleSave = () => {
        dispatch(editarDetalleCotizaciones({ NuevosDetalles: info }, idEstado, idTipoSolicitud));
        if (esEdicion) {
            dispatch(props.closeModalHandler)
        }
    }

    useEffect(() => {
        if (materialCompras !== null) {
            var material = info.find(x => x.idMaterial === materialCompras.idMaterial);
            if (material === undefined) {
                setInfo(info => info.concat(materialCompras));
            } else {
                dispatch(startAlerta('Ese material ya se encuentra cargado.', "warning", `¡Error!`));
            }
        }
    }, [materialCompras])

    useEffect(() => {
        if (esEdicion) {
            setOferentes(idOferenteEdicion)
        }
    }, [dispatch, esEdicion])

    useEffect(() => {
        setInfo([])
    }, [dispatch, idOferente])
    return (
        <>
            {
                openDocumentacion && (
                    <ModalDocumentacion
                        open={openDocumentacion}
                        closeModalHandler={() => { setDocumentacionAlta(false); }}
                        idCotizacionCabecera={cabeceraElegida.find((x) => x.idCabeceraCotizacion).idCabeceraCotizacion}
                        idOferente={idOferente}
                        idEstado={idEstado}
                    />
                )
            }
            {
                openModalCargarOferente && (
                    <ModalCargarOferente
                        open={openModalCargarOferente}
                        closeModalHandler={() => setOpenModalCargarOferente(false)}
                        idCotizacion={cotizacion?.idCotizacion}
                        idTipoSolicitud={idTipoSolicitud}
                        idEstado={idEstado}
                    />
                )
            }
            <Dialog
                fullWidth
                maxWidth={'lg'}
                open={props.open}>
                <DialogTitle style={{ textAlign: 'center' }}>Cargar Cotizacion Orden N° {idSolicitud}</DialogTitle>
                <DialogContent>
                    <Grid item xs={12} style={{ display: 'flex', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <Grid item xs={12} style={{ display: 'flex' }}>
                            <InputLabel style={{ marginTop: '1rem', marginRight: '1rem' }}>Oferente</InputLabel>
                            <Select
                                label="Oferentes"
                                name="idOferente"
                                value={idOferente}
                                onChange={(e) =>
                                    setOferentes(e.target.value)}
                                disabled={esEdicion ? true : false}

                            >

                                <MenuItem value={0}>
                                    <em>Seleccione Oferente</em>
                                </MenuItem>
                                {
                                    oferentes?.map((item) => (
                                        <MenuItem key={item.idOferente} value={item.idOferente}>
                                            {item.razonSocial}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </Grid>
                        {Number(idEstado) === ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS && (
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'right' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setOpenModalCargarOferente(true)}
                                >
                                    + Agregar Oferente
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                    {idOferente !== 0 &&
                        <>
                            <ModalAbm title="Agregar Material" open={openMaterial} setOpen={setMaterialAlta}>
                                <FormNuevoMaterial material={null} idSolicitud={idSolicitud} idCotizacionCabecera={cabeceraElegida.find((x) => x.idCabeceraCotizacion).idCabeceraCotizacion} idOferente={idOferente} idEstado={idEstado} cerrarModal={() => setMaterialAlta(false)} />
                            </ModalAbm>
                            <ModalAbm title="Modificar Material" open={open} setOpen={setOpen}>
                                <FormNuevoMaterial material={material} handleEdit={handleEdit} cerrarModal={() => setOpen(false)} />
                            </ModalAbm>
                            <Button variant="contained" color="primary" onClick={() => setMaterialAlta(true)} style={{ float: "right", margin: "1rem" }}>+ Agregar Material</Button>
                            <Button variant="contained" color="primary" onClick={() => setDocumentacionAlta(true)} style={{ float: "right", margin: "1rem" }}>Documentacion</Button>
                            {Number(idEstado) === ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => dispatch(enviarMailPedidoCotizacion(idSolicitud, idOferente))}
                                    style={{ float: "right", margin: "1rem" }}
                                >
                                    Re-Enviar Mail Pedido Cotizacion
                                </Button>
                        )}
                            <TableContainer style={{ overflowX: "auto", marginTop: '1rem', padding: '0.5rem' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Material</TableCell>
                                            <TableCell>Cantidad</TableCell>
                                            <TableCell>Cantidad Cotizada</TableCell>
                                            <TableCell>Precio Unitario</TableCell>
                                            <TableCell>Fecha de Entrega</TableCell>
                                            <TableCell>Observaciones</TableCell>
                                            <TableCell>Precio Total</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {info.length > 0 && (
                                            info.map((a) => (
                                                <TableRow key={a.idDetalleCotizacion}>
                                                    <Tooltip title={a.agregadoCompras === true ? 'Agregado en Compras' : ''}>
                                                        <TableCell style={{ color: a.agregadoCompras === true ? 'green' : 'black' }}>
                                                            {a.material}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <TableCell>{a.cantidad}</TableCell>
                                                    <TableCell>{a.cantidadCotizada ? a.cantidadCotizada : '-'}</TableCell>
                                                    <TableCell>{a.valorUnitario ? a.valorUnitario : '-'}</TableCell>
                                                    <TableCell>{a.fechaEntrega ? moment(a.fechaEntrega).format("DD/MM/yyyy") : '-'}</TableCell>
                                                    <TableCell>{a.observaciones ? a.observaciones : '-'}</TableCell>
                                                    <TableCell>${a.cantidadCotizada * a.valorUnitario} </TableCell>
                                                    <TableCell><Button tabIndex="-1" onClick={() => handleItemSelectEliminar(a)}><DeleteOutlineOutlinedIcon style={{ color: 'red' }} /></Button>
                                                        <AlertFinalizadoStepper
                                                            open={confirmarEliminarMaterial}
                                                            pregunta={"Eliminar Material"}
                                                            dialogText={`Esta seguro de eliminar el material?`}
                                                            buttonCancel={"Cancelar"}
                                                            buttonSubmit={"Confirmar"}
                                                            handleClose={() => setConfirmarEliminarMaterial(false)}
                                                            handleSend={() => {
                                                                handleEliminar();
                                                                setConfirmarEliminarMaterial(false);
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell><Button onClick={() => handleItemSelect(a)}><EditIcon /></Button></TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Grid container style={{ padding: '25px' }}>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={1}
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Button
                                            color="inherit"
                                            variant="contained"
                                            onClick={() => {
                                                dispatch(props.closeModalHandler);
                                            }}
                                        >
                                            Cerrar
                                        </Button>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={() => handleSave()}
                                            style={{ marginLeft: '1rem' }}

                                        >
                                            Guardar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>

                    }
                    {idOferente === 0 && (
                        <Grid container style={{ padding: '25px' }}>
                            <Grid item xs={12}>
                                <Grid
                                    container
                                    spacing={1}
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Button
                                        color="inherit"
                                        variant="contained"
                                        onClick={() =>
                                            dispatch(props.closeModalHandler)
                                        }
                                    >
                                        Cerrar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
            </Dialog>
        </>
    )
});